"use strict";

var reduce = require("../Strict/reduce.js");

var mapL = require("../Lazy/mapL.js");

var entriesL = require("../Lazy/entriesL.js");

module.exports = baseExtend;

function baseExtend(set, obj, objs) {
  const type = typeof obj;
  obj && (type == 'object' || type == 'function') && reduce(reduce(set), obj, mapL(entriesL, objs));
  return obj;
}